import { createConfigExperiment, getExperiment } from '@pegasus/abtesting';
import { useSelector } from 'react-redux';

const PROJECT_ID = '3d064362-338a-4cbe-843a-7c238d4572cb';
const SHOWSTOPPER_LONG_CONTROL = 'old_long_showstopper';
const SHOWSTOPPER_SHORT_VARIANT = 'shorter_showstopper';

export const useRedesignedShowstopper = () => {
    // @ts-ignore
    const experiment = useSelector(state => getExperiment(state, PROJECT_ID));
    if (!experiment) {
        return false;
    }

    // @ts-ignore
    return experiment?.variant === SHOWSTOPPER_SHORT_VARIANT;
};

export default createConfigExperiment({
    projectId: PROJECT_ID,
    variants: [SHOWSTOPPER_LONG_CONTROL, SHOWSTOPPER_SHORT_VARIANT],
});
